import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Lead } from 'models/Lead';
import { getUserFullNameOrEmail } from 'utils';
import {
  LEAD_NOTIFICATION_STATUS,
  LEAD_NOTIFICATIONS_TRANSLATIONS_FAILED,
  LEAD_NOTIFICATIONS_TRANSLATIONS_OPENED,
  LEAD_NOTIFICATIONS_TRANSLATIONS_RECEIVED,
  LeadNotificationStatus,
} from 'models/LeadNotifications';

const COPY = {
  [LEAD_NOTIFICATION_STATUS.RECEIVED]: LEAD_NOTIFICATIONS_TRANSLATIONS_RECEIVED,
  [LEAD_NOTIFICATION_STATUS.OPENED]: LEAD_NOTIFICATIONS_TRANSLATIONS_OPENED,
  [LEAD_NOTIFICATION_STATUS.FAILED]: LEAD_NOTIFICATIONS_TRANSLATIONS_FAILED,
};

export default function useLeadNotificationCopy() {
  const { t } = useTranslation();

  return useCallback(
    (typeCode: number, status: LeadNotificationStatus, lead: Partial<Lead>) => {
      if (!typeCode || !status || !lead) return '';

      return t(COPY[status][typeCode], {
        leadName: getUserFullNameOrEmail(lead),
      });
    },
    [t],
  );
}
